document.addEventListener('DOMContentLoaded', function(){
    const accordionItems    = document.querySelectorAll('[data-popup-links-button]');
  	const popUpContainer 	= document.querySelector('[data-popup-links]');
  	const popupClose 	    = document.querySelector('[data-popup-links-close]');

    if(accordionItems.length > 0 && popUpContainer && popupClose){

        document.querySelector('body').append(popUpContainer)

        accordionItems.forEach(item => {
            item.addEventListener('click', (evt) => {
                const dataToShow        = evt.target.dataset.stepPopup;
                const elementsToTrigger = document.querySelectorAll('[data-pop-up-content]');

                if(elementsToTrigger.length > 0){
                    elementsToTrigger.forEach(elem => elem.classList.add('hidden'))
                    const elementsMatched = document.querySelectorAll(`[data-${dataToShow}-content]`);
                    if(elementsMatched.length > 0) {
                        elementsMatched.forEach(elem => {
                            elem.classList.remove('hidden')
                        })

                        popUpContainer.classList.remove('hidden')
                    }
                }
            })
        })
       
        popupClose.addEventListener('click', (evt) => {
        	popUpContainer.classList.add("hidden");
        })
        
    }
  
})